
import { ToastOptions } from "react-toastify";
export const API_BASE = process.env.NODE_ENV === 'development' ? "http://localhost:8000" : "";

export const COMPANY_WEBSITE ="https://maritaca.ai";
export const PLATFORM_WEBSITE = "https://plataforma.maritaca.ai";
export const API_PUBLIC_REPOSITORY ="https://github.com/maritaca-ai/maritalk-api";
export const PRODUCT_TERMS_AND_POLICY ="https://www.maritaca.ai/termos-e-condicoes";
export const PRODUCT_PRIVACY_POLICY ="https://www.maritaca.ai/politica-de-privacidade";

export const TOAST_CONFIG: ToastOptions = {
    position: "top-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
}

export const API_KEY_TOAST_CONFIG:ToastOptions = {
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "dark",
}

export const CodeBlockTheme = {
    lineNumberColor: "#ccc",
    lineNumberBgColor: "#222",
    backgroundColor: "#222",
    textColor: "#ccc",
    substringColor: "#00ff00",
    keywordColor: "#0077ff",
    attributeColor: "#ffaa00",
    selectorTagColor: "#0077ff",
    docTagColor: "#aa00ff",
    nameColor: "#f8f8f8",
    builtInColor: "#0077ff",
    literalColor: "#ffaa00",
    bulletColor: "#ffaa00",
    codeColor: "#ccc",
    additionColor: "#00ff00",
    regexpColor: "#f8f8f8",
    symbolColor: "#ffaa00",
    variableColor: "#ffaa00",
    templateVariableColor: "#ffaa00",
    linkColor: "#aa00ff",
    selectorAttributeColor: "#ffaa00",
    selectorPseudoColor: "#aa00ff",
    typeColor: "#0077ff",
    stringColor: "#00ff00",
    selectorIdColor: "#ffaa00",
    quoteColor: "#f8f8f8",
    templateTagColor: "#ccc",
    deletionColor: "#ff0000",
    titleColor: "#0077ff",
    sectionColor: "#0077ff",
    commentColor: "#777",
    metaKeywordColor: "#f8f8f8",
    metaColor: "#aa00ff",
    functionColor: "#0077ff",
    numberColor: "#ffaa00",
  };

  export const codeLanguageSubset = [
    'python',
    'javascript',
    'java',
    'go',
    'bash',
    'c',
    'cpp',
    'csharp',
    'css',
    'diff',
    'graphql',
    'json',
    'kotlin',
    'less',
    'lua',
    'makefile',
    'markdown',
    'objectivec',
    'perl',
    'php',
    'php-template',
    'plaintext',
    'python-repl',
    'r',
    'ruby',
    'rust',
    'scss',
    'shell',
    'sql',
    'swift',
    'typescript',
    'vbnet',
    'wasm',
    'xml',
    'yaml',
  ];

// Cores da marca Maritaca
export const BRAND_COLORS = {
  darkGreen: '#1a3c34',
  green: '#70d44b',
  orange: '#ff7f40',
  lime: '#e6f57b',
  mint: '#bddfc5',
};

// Paleta de cores por modelo (light mode)
export const MODEL_COLORS: { [key: string]: { primary: string; secondary: string; accent: string } } = {
  'sabia-4-pro': {
    primary: '#70d44b',    // verde (modelo principal)
    secondary: '#a8e986',
    accent: '#5bc438',
  },
  'sabia-4': {
    primary: '#70d44b',    // verde (modelo principal)
    secondary: '#a8e986',
    accent: '#5bc438',
  },
  'sabia-5': { primary: '#70d44b', secondary: '#a8e986', accent: '#5bc438' },
  'sabia-4-thinking': {
    primary: '#70d44b',    // verde (mesma identidade do sabia-4 — o thinking é o default)
    secondary: '#a8e986',
    accent: '#5bc438',
  },
  'sabiazinho-4': {
    primary: '#bddfc5',    // verde água/menta
    secondary: '#d4ebe0',
    accent: '#9fd1ab',
  },
  'sabiazinho-4-pro': {
    primary: '#bddfc5',    // verde água/menta (igual sabiazinho-4)
    secondary: '#d4ebe0',
    accent: '#9fd1ab',
  },
  'sabia-3.1': {
    primary: '#1a3c34',    // verde escuro (marca)
    secondary: '#2d5c50',
    accent: '#143029',
  },
  'sabia-3': {
    primary: '#c5d44a',    // lima (mais escuro)
    secondary: '#d9e87a',
    accent: '#a8b83a',
  },
  'sabiazinho-3': {
    primary: '#ff7f40',    // laranja
    secondary: '#fccab1',
    accent: '#ff6b2b',
  },
};

// Paleta de cores por modelo (dark mode - para modelos com baixo contraste)
export const MODEL_COLORS_DARK: { [key: string]: { primary: string; secondary: string; accent: string } } = {
  'sabia-3.1': {
    primary: '#4a9a85',    // verde médio (legível em dark mode)
    secondary: '#6bb5a0',
    accent: '#3d8070',
  },
};

// Cor padrão (fallback)
export const DEFAULT_MODEL_COLOR = {
  primary: '#70d44b',
  secondary: '#a8e986',
  accent: '#5bc438',
};

// Helper para obter cor do modelo
export const getModelColor = (model: string, isDark?: boolean) => {
  if (isDark && MODEL_COLORS_DARK[model]) {
    return MODEL_COLORS_DARK[model];
  }
  return MODEL_COLORS[model] || DEFAULT_MODEL_COLOR;
};

// Gerar gradients para background
export const getModelGradient = (model: string, isDark: boolean) => {
  const colors = getModelColor(model);
  if (isDark) {
    return {
      strong: `rgba(${hexToRgb(colors.primary)}, 0.22)`,
      soft: `rgba(${hexToRgb(colors.primary)}, 0.11)`,
      fade: `rgba(${hexToRgb(colors.primary)}, 0)`,
    };
  }
  return {
    color: `rgba(${hexToRgb(colors.primary)}, 0.45)`,
    fade: `rgba(${hexToRgb(colors.primary)}, 0)`,
  };
};

// Helper para converter hex para rgb
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
  }
  return '112, 212, 75'; // fallback verde
};
